
import React, { useState } from "react";
import { AnalyticsHeader } from "@/components/analytics/AnalyticsHeader";
import { AnalyticsDashboard } from "@/components/analytics/AnalyticsDashboard";
import { useAnalyticsSettings } from "@/components/analytics/hooks/useAnalyticsSettings";
import type { AnalyticsConfig } from "@/components/analytics/components/AnalyticsSettings";

const Analytics = () => {
  const [dateRange, setDateRange] = useState<{ from: Date; to: Date } | undefined>();
  const [refreshKey, setRefreshKey] = useState(0);
  const { settings, updateSettings } = useAnalyticsSettings();

  const handleDateRangeChange = (range: { from: Date; to: Date }) => {
    setDateRange(range);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleSettingsChange = (newSettings: AnalyticsConfig) => {
    updateSettings(newSettings);
  };

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-7xl mx-auto">
        <AnalyticsHeader 
          onDateRangeChange={handleDateRangeChange}
          onRefresh={handleRefresh}
          onSettingsChange={handleSettingsChange}
          candidates={[]} // Will be passed from AnalyticsDashboard's data
        />
        <AnalyticsDashboard 
          dateRange={dateRange}
          onRefresh={handleRefresh}
          settings={settings}
          key={refreshKey}
        />
      </div>
    </div>
  );
};

export default Analytics;
